<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.treatment') }}
    </p>
    <VTextarea
      v-model="data.AROtherAdditionalInfo"
      :label="$t('forms.labels.info')"
      :rules="{ required: true, min: 1, max: 10000 }"
      outlined
      data-cy="cyArOtherAdditionalInfo"
    />
  </div>
</template>

<script>
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';

export default {
    components: {
        VTextarea,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data: {
                AROtherAdditionalInfo: this.analysisRequest.AROtherAdditionalInfo,
            },
        };
    },
    watch: {
        data: {
            handler() {
                this.$emit('updateData', this.data);
            },
            deep: true,
        },
    },
};
</script>
